import { ArrowRight, CalendarDays, School, Mail } from "lucide-react";

export default function SchoolsHero() {
    return (
        <section className="relative overflow-hidden bg-[#fff2cf] mt-10">
            {/* Background image placeholder */}
            <div
                className="absolute inset-0 bg-cover bg-center opacity-25"
                style={{
                    backgroundImage: "url('/assets/HeroBackground.png')",
                }}
            />

            {/* Comic burst / halftone texture */}
            <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(0,0,0,0.09)_1px,transparent_1px)] [background-size:14px_14px] opacity-60" />

            <div className="relative mx-auto grid max-w-6xl gap-10 px-6 py-16 md:grid-cols-[1.05fr_0.95fr] md:items-center md:py-20 lg:px-8">
                <div>
                    <div className="mb-5 inline-flex rotate-[-1deg] items-center gap-2 border-[3px] border-black bg-[#ff3366] px-4 py-2 text-xs font-black uppercase text-white shadow-[4px_4px_0_#000] md:text-sm">
                        <School size={18} strokeWidth={3} />
                        For Schools
                    </div>

                    <h1 className="text-4xl font-black uppercase leading-[0.95] tracking-tight md:text-6xl">
                        Turn Bystanders into
                        <span className="block text-[#16bdf4] drop-shadow-[3px_3px_0_#000]">
                            Upstanders.
                        </span>
                    </h1>
                     <h1 className="text-2xl font-black uppercase leading-[0.95] tracking-tight md:text-4xl mt-4">
                        Transform Your School Culture.
                    </h1>

                    <p className="mt-6 max-w-2xl text-base font-bold leading-8 md:text-lg">
                        Bring real conversations into your classrooms with{" "}
                        <span className="font-black text-[#ff3366]">Call It Out</span>—an
                        interactive anti-bullying experience that empowers students to
                        speak up, support one another, and build a culture of respect.
                    </p>

                    <div className="mt-7 flex flex-col gap-3 sm:flex-row">
                        <a
                            href="mailto:playtohealgames@gmail.com?subject=Call%20It%20Out%20Demo%20Request&body=Hi,%20I’m%20interested%20in%20bringing%20Call%20It%20Out%20to%20my%20school.%20Please%20share%20more%20details."
                            className="inline-flex items-center justify-center gap-2 rounded-md border-[3px] border-black bg-[#ffbc00] px-5 py-3 text-sm font-black uppercase text-black shadow-[5px_5px_0_#000] transition hover:-translate-y-1 hover:shadow-[7px_7px_0_#000]"
                        >
                            <Mail size={18} strokeWidth={3} />
                            Bring Call It Out to Your School
                            <ArrowRight size={18} strokeWidth={3} />
                        </a>

                        {/* <a
                            href="mailto:playtohealgames@gmail.com?subject=Call%20It%20Out%20Demo%20Request&body=Hi,%20I’m%20interested%20in%20bringing%20Call%20It%20Out%20to%20my%20school.%20Please%20share%20more%20details."
                            className="inline-flex items-center justify-center gap-2 rounded-md border-[3px] border-black bg-white px-5 py-3 text-sm font-black uppercase text-black shadow-[5px_5px_0_#000] transition hover:-translate-y-1 hover:shadow-[7px_7px_0_#000]"
                            >
                            Request a Demo
                            <CalendarDays size={18} strokeWidth={3} />
                        </a> */}
                    </div>
                </div>

                <div className="relative">
                    <div className="rotate-[1deg] rounded-[24px] border-[5px] border-black bg-white p-4 shadow-[9px_9px_0_#000]">
                        {/* Main hero image placeholder */}
                        <div
                            className="min-h-[280px] rounded-[16px] border-[3px] border-black bg-[#dff2ff] bg-cover bg-center md:min-h-[380px]"
                            style={{
                                backgroundImage: "url('/assets/Evironments-768x576.jpg')",
                            }}
                        />

                        <div className="mt-4 grid grid-cols-3 gap-2">
                            <div className="rounded-md border-[2px] border-black bg-[#ff3366] px-2 py-2 text-center text-[10px] font-black uppercase text-white">
                                Speak Up
                            </div>
                            <div className="rounded-md border-[2px] border-black bg-[#16bdf4] px-2 py-2 text-center text-[10px] font-black uppercase">
                                Stand Tall
                            </div>
                            <div className="rounded-md border-[2px] border-black bg-[#ffbc00] px-2 py-2 text-center text-[10px] font-black uppercase">
                                Create Change
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}